import API from "api";
import { useContext, useEffect, useState } from "react";
import StyledDateSelect from "utils/select/DateSelect/StyledDateSelect";
import { DashbaordMerchantChartWrapper } from "./DashbaordMerchantChartWrapper";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { ReactComponent as InfoCircleGray } from "assets/images/icons/info-circle-gray.svg";
import { ReactComponent as UserProfile } from "assets/images/icons/profile-icon.svg";
import { ReactComponent as SmileyProfile } from "assets/images/icons/smiley-icon.svg";
import { ReactComponent as Linegraph } from "assets/images/icons/line-graph.svg";
import { loadingOption, totalDashMerchantOptions } from "../../helpers";
import ReactECharts from "echarts-for-react";
import { useQuery } from "react-query";
import {
  getActiveMerchants,
  getTotalCommission,
  getTotalMerchants,
} from "api/dashboard";
import { AuthContext } from "utils/context/AuthContext";

function DashbaordMerchantChart() {
  const { id } = useContext(AuthContext);
  const [dateRange, setDateRange] = useState("Today");
  const [dateRange2, setDateRange2] = useState("Week");
  let timer;

  useEffect(() => {
    return () => clearTimeout(timer);
  });
  const getTotalMerchantsQuery = useQuery(
    ["totalMerchants", dateRange, id],
    async () => {
      const response = await API.get(getTotalMerchants, {
        params: {
          companyId: id,
          filter: dateRange.toLowerCase(),
        },
      });
      return response.data.data;
    },
    {
      keepPreviousData: true,
      refetchOnWindowFocus: false,
    }
  );
  const getTotalCommissionQuery = useQuery(
    ["totalCommision", dateRange, id],
    async () => {
      const response = await API.get(getTotalCommission, {
        params: {
          companyId: id,
          period: dateRange.toLowerCase(),
        },
      });
      return response.data.data;
    },
    {
      keepPreviousData: true,
      refetchOnWindowFocus: false,
    }
  );
  const getActiveUsersQuery = useQuery(
    ["ativeUsers", dateRange2, id],
    async () => {
      const response = await API.get(getActiveMerchants, {
        params: {
          companyId: id,
          filter: dateRange2.toLowerCase(),
        },
      });
      return response.data.data;
    },
    {
      keepPreviousData: true,
      refetchOnWindowFocus: false,
    }
  );

  function onChartReady(echarts) {
    timer = setTimeout(function () {
      echarts.hideLoading();
    }, 3000);
  }
  return (
    <DashbaordMerchantChartWrapper className="col-md-6 col-lg-4 p-4 pl-0">
      <div className="bg-white rounded-card p-4">
        <div className="">
          <div className="">
            <div className="flex__between p-4 ">
              <div>
                <p className="text--grey heading-4">
                  Total Merchants{" "}
                  <OverlayTrigger
                    placement="right"
                    overlay={
                      <Tooltip id="tooltip-right">
                        Total Amount of money that was paid into your wallet.
                        This is the sum of all payments plus charges
                      </Tooltip>
                    }
                  >
                    <span className="d-inline-block">
                      <InfoCircleGray className="ms-2 pointer" />
                    </span>
                  </OverlayTrigger>
                </p>
              </div>
              <StyledDateSelect
                wrapperCls="col-5 col-sm-6"
                cls="col-9 col-sm-10"
                name="date-select"
                formLabel="date-select"
                onChange={(e) => setDateRange(e)}
                options={["Today", "Month", "Year"]}
                value={dateRange}
              />
            </div>
            <div className="row border rounded">
              <div className="col-sm-6 p-4">
                <div className=" p-4 rounded">
                  <UserProfile />
                  <p className="black text--xl text-break mb-0">
                    {getTotalMerchantsQuery?.data?.merchantCount || 0}
                  </p>
                  <p className="text--grey heading-4 mt-0">Merchants </p>
                  <div className="d-flex">
                    <Linegraph width={80} />
                    <div>
                      <p className="black text--sm text-break mb-0 text-success fw-bold">
                        {getTotalMerchantsQuery?.data?.percentageIncrease || 0}%
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-sm-6 p-4">
                <div className="bg-secondary-accent-theta p-4 rounded">
                  <SmileyProfile />
                  <p className="black text--xl text-break mb-0">
                    {getTotalCommissionQuery?.data?.commissionCount}
                  </p>
                  <p className="text--grey heading-4 mt-0">
                    Total Commissions{" "}
                  </p>
                  <div className="d-flex">
                    <Linegraph
                      style={{
                        transform: "rotateX(180deg)",
                      }}
                      width={80}
                    />
                    <div>
                      <p className="black text--sm text-break mb-0 text-success fw-bold">
                        {getTotalCommissionQuery?.data?.percentageIncrease || 0}
                        %
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="mt-0">
            <div className="flex__between p-4 ">
              <div>
                <p className="text--grey heading-4">
                  Active Users{" "}
                  <OverlayTrigger
                    placement="right"
                    overlay={
                      <Tooltip id="tooltip-right">Total Active Users</Tooltip>
                    }
                  >
                    <span className="d-inline-block">
                      <InfoCircleGray className="ms-2 pointer" />
                    </span>
                  </OverlayTrigger>
                </p>
              </div>
              <StyledDateSelect
                wrapperCls="col-5 col-sm-6"
                cls="col-9 col-sm-10"
                name="date-select"
                formLabel="date-select"
                onChange={(e) => setDateRange2(e)}
                options={["Week", "Year"]}
                value={dateRange2}
              />
            </div>
            <ReactECharts
              loadingOption={loadingOption}
              onChartReady={onChartReady}
              option={totalDashMerchantOptions(getActiveUsersQuery?.data)}
              opts={{ renderer: "svg" }}
              showLoading={getActiveUsersQuery?.isLoading}
              style={{
                height: "218px",
                minWidth: "100%",
              }}
            />
          </div>
        </div>
      </div>
    </DashbaordMerchantChartWrapper>
  );
}

export default DashbaordMerchantChart;
